import React from 'react';
import { Stethoscope, Shield, Syringe, Pill, HeartPulse, Ambulance } from 'lucide-react';
import { useInView } from 'react-intersection-observer';

const benefits = [
  {
    icon: Shield,
    title: 'Certificaciones Médicas',
    description: 'Productos avalados por los más altos estándares de calidad internacional',
    gradient: 'from-primary to-secondary',
  },
  {
    icon: Stethoscope,
    title: 'Profesionales Certificados',
    description: 'Asesoramiento especializado de personal médico calificado',
    gradient: 'from-accent to-dark',
  },
  {
    icon: Stethoscope,
    title: 'Suministros de Emergencia',
    description: 'Kits médicos completos para cualquier situación crítica',
    gradient: 'from-secondary to-accent',
  },
  {
    icon: Stethoscope,
    title: 'Equipamiento Completo',
    description: 'Tecnología médica de última generación para instituciones',
    gradient: 'from-primary to-accent',
  },
  {
    icon: Syringe,
    title: 'Insumos Estériles',
    description: 'Materiales desechables con protocolos de esterilización certificados',
    gradient: 'from-dark to-secondary',
  },
  {
    icon: Pill,
    title: 'Farmacia Especializada',
    description: 'Medicamentos esenciales y tratamientos especializados',
    gradient: 'from-accent to-primary',
  },
  {
    icon: HeartPulse,
    title: 'Cuidado Preventivo',
    description: 'Equipos de monitoreo y diagnóstico temprano',
    gradient: 'from-secondary to-dark',
  },
  {
    icon: Ambulance,
    title: 'Despacho Inmediato',
    description: 'Servicio express de entrega para casos urgentes',
    gradient: 'from-primary to-dark',
  },
];

export const Benefits = () => {
  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

  return (
    <div className="relative py-28 md:px-24 bg-main-bg overflow-hidden">
      <div className="container mx-auto px-6">
        {/* Elementos de fondo animados */}
        <div
         
          className="absolute -top-20 -right-20 w-96 h-96 bg-primary/10 rounded-full blur-3xl"
        />
        <div
         
          className="absolute -bottom-20 -left-20 w-96 h-96 bg-secondary/10 rounded-full blur-3xl"
        />

        {/* Encabezado */}
        <div
          ref={ref}
         
          className="text-center mb-20 relative"
        >
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-8 h-[2px] bg-accent" />
            <span className="text-accent uppercase tracking-widest text-sm font-semibold font-poppins">
              Por Qué Elegirnos
            </span>
            <div className="w-8 h-[2px] bg-accent" />
          </div>
          <h2 className="text-3xl font-bold text-primary-dark mb-6 font-montserrat">
            Su Proveedor Médico de Confianza
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed font-poppins">
            Más de una década proporcionando soluciones integrales en equipamiento e insumos médicos
            con los más altos estándares de calidad y servicio profesional.
          </p>
        </div>

        {/* Grid de Beneficios */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
               
                className="group relative"
              >
                <div className="absolute inset-0 bg-section-bg rounded-2xl transition-all group-hover:bg-primary/5 backdrop-blur-lg border border-gray-200 group-hover:border-accent/30" />
                
                <div className="relative p-8 h-full">
                  {/* Ícono con gradiente */}
                  <div className={`mb-8 w-14 h-14 rounded-2xl bg-gradient-to-r ${benefit.gradient} 
                    flex items-center justify-center shadow-lg`}>
                    <Icon className="h-6 w-6 text-white" />
                  </div>

                  {/* Contenido */}
                  <h3 className="text-2xl font-semibold text-primary-dark mb-4 font-montserrat">{benefit.title}</h3>
                  <p className="text-gray-600 leading-relaxed font-poppins">{benefit.description}</p>

                  {/* Efecto hover */}
                  <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </div>
            );
          })}
        </div>

        {/* Estadísticas */}
        <div
          
          className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-20 border-t border-gray-200 pt-12"
        >
          {[
            { number: '5K+', label: 'Insumos Médicos' },
            { number: '99%', label: 'Satisfacción' },
            { number: '200+', label: 'Profesionales' },
            { number: '12', label: 'Años Experiencia' },
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl font-bold text-accent mb-2 font-montserrat">
                <span
                 
                >
                  {stat.number}
                </span>
              </div>
              <div className="text-sm text-primary-dark uppercase tracking-widest font-poppins">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};